(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/game/assets/javascripts/netent-livedata.js') >= 0) return;  svs.modules.push('/components/casino/game/assets/javascripts/netent-livedata.js');

'use strict';

const log = svs.core.log.getLogger('component.casino.game.netent-livedata');
class NetEntLivedata extends svs.components.casino.PubSub {
  constructor() {
    super();
    this.resultTypes = {
      DEALER_ROULETTE: 'roulette',
      AUTOMATIC_ROULETTE: 'roulette'
    };
    const {
      staticServer,
      gameInclusion
    } = svs.components.casino.data.liveInfo;
    this.netentExtendURL = staticServer + gameInclusion;
    this.installScript();
  }
  installScript() {
    if (window.netent === undefined) {
      window.netent = null;
      $.getScript(this.netentExtendURL).done(() => {
        this.listen();
      }).fail((jqxhr, settings, exception) => {
        log.error('Cannot load NetEnt Extend:', JSON.stringify(exception));
      });
    }
  }
  listen() {
    if (window.netent && !this.netentListener && this.subscriptions > 0) {
      this.update();
      this.netentListener = setInterval(() => {
        this.update();
      }, svs.components.casino.data.liveInfo.liveDataPollingInterval);
    }
  }
  unListen() {
    this.netentListener = clearInterval(this.netentListener);
  }
  update() {
    const neConfig = svs.components.casino.data.liveInfo;
    const config = {
      gameServerURL: neConfig.liveCasinoHost,
      staticServer: neConfig.staticServer,
      casinoId: neConfig.operatorId,
      currency: 'SEK'
    };
    window.netent.getOpenTables(config, result => {
      try {
        const games = this.processOpenTables(result);
        this.emit('update', games);
      } catch (e) {
        log.error('Error processing getOpenTables:', JSON.stringify(e));
      }
    }, e => {
      log.error('Error from getOpenTables:', JSON.stringify(e));
    });
  }
  emit(event, games) {
    this.callbacks[event].forEach(callback => {
      const gameId = svs.core.detect.formfactor.mobile() ? callback.context.providerGameIdMobile : callback.context.providerGameId;
      callback.callback.call(callback.context, {
        game: games[gameId]
      });
    });
  }
  on() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    super.on.apply(this, args);
    this.listen();
  }
  off() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    super.off.apply(this, args);
    if (this.subscriptions === 0) {
      this.unListen();
    }
  }
  calculateSeatsTaken(slots) {
    if (slots.unlimited) {
      return null;
    }
    const seatsTaken = [];
    const availableSlots = new Set(slots.availableSlots);
    for (let seat = 1; seat < slots.total; seat++) {
      if (!availableSlots.has(seat)) {
        seatsTaken.push(seat);
      }
    }
    return seatsTaken;
  }
  parseResults(table) {
    switch (table.tableType) {
      case 'DEALER_ROULETTE':
      case 'AUTOMATIC_ROULETTE':
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => String(table.statistics["number.".concat(n)]));
      default:
        return null;
    }
  }
  processOpenTables(openTables) {
    const games = {};
    for (const tableIndex of Object.keys(openTables)) {
      const table = openTables[tableIndex];
      for (const game of table.games) {
        games[game.gameId] = {
          gameId: table.tableId,
          players: table.statistics.playerCount,
          betLimits: [{
            currency: 'SEK',
            symbol: 'kr',
            min: game.minBet / 100,
            max: game.maxBet / 100
          }],
          gameState: 1,
          seats: table.slots.unlimited ? 0 : table.slots.total,
          seatsTaken: this.calculateSeatsTaken(table.slots),
          betBehind: false,
          liveResultType: this.resultTypes[table.tableType] || 'other',
          results: this.parseResults(table),
          openHours: {
            type: null,
            startTime: null,
            endTime: null
          }
        };
      }
    }
    return games;
  }
}

setGlobal('svs.components.casino.game.NetEntLivedata', NetEntLivedata);

 })(window);